import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { useInboxPreviewContext } from './InboxPreviewContext';
import MessageWithHomeButton from './MessageWithHomeButton';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const PageStates = ({ children }) => {
  const { t } = useTranslation();

  const [
    {
      successfulPayment,
      isTrialer,
      alreadyPurchased,
      isSingleBilledAccount,
      isPartnerBilledAccount,
      isEntitled,
      errorMessage,
      urlParamPromoCode,
      rating,
      isSuspended,
      isAccountDisabled,
      embedded,
    },
  ] = useInboxPreviewContext();

  if (alreadyPurchased == null || embedded === null) {
    return (
      <div id="inbox-loading-indicator">
        <img src="//static.ctctcdn.com/ui/images/loading-animation-teal.gif" alt={t('add-inbox-preview.loading')} />
      </div>
    );
  }

  if (isTrialer) {
    return (
      <MessageWithHomeButton showButton={!embedded}>
        <h1>{t('add-inbox-preview.not-for-trialers')}</h1>
      </MessageWithHomeButton>
    );
  }

  if (isSuspended) {
    return (
      <MessageWithHomeButton showButton={!embedded}>
        <h1>{t('add-inbox-preview.account-suspended')}</h1>
      </MessageWithHomeButton>
    );
  }

  if (isAccountDisabled) {
    return (
      <MessageWithHomeButton showButton={!embedded}>
        <h1>{t('add-inbox-preview.account-disabled')}</h1>
      </MessageWithHomeButton>
    );
  }

  if (errorMessage) {
    return (
      <MessageWithHomeButton showButton={!embedded}>
        <Trans i18nKey="add-inbox-preview.error-purchasing" values={{ errorMsg: errorMessage }}>
          <h1>error</h1>
        </Trans>
      </MessageWithHomeButton>
    );
  }

  if (!isEntitled)
    return (
      <MessageWithHomeButton showButton={!embedded}>
        <Trans i18nKey="add-inbox-preview.is-not-entitled">
          <h1>time to upgrade</h1>
          <p>more</p>
        </Trans>
      </MessageWithHomeButton>
    );

  if (isSingleBilledAccount)
    return (
      <MessageWithHomeButton showButton={!embedded}>
        <Trans i18nKey="add-inbox-preview.single-billed-account">
          <h1>time to upgrade</h1>
          <p>more</p>
          <p>more</p>
        </Trans>
      </MessageWithHomeButton>
    );

  if (isPartnerBilledAccount)
    return (
      <MessageWithHomeButton showButton={!embedded}>
        <Trans i18nKey="add-inbox-preview.partner-billed-account">
          <h1>time to upgrade</h1>
          <p>more</p>
          <p>more</p>
        </Trans>
      </MessageWithHomeButton>
    );

  if (alreadyPurchased)
    return (
      <MessageWithHomeButton>
        <h3>{t('add-inbox-preview.you-already-have-inbox-preview')}</h3>
      </MessageWithHomeButton>
    );

  if (urlParamPromoCode && !rating)
    return <img src="//static.ctctcdn.com/ui/images/loading-animation-teal.gif" alt={t('add-inbox-preview.loading')} />;

  if (successfulPayment)
    return (
      <MessageWithHomeButton>
        <Trans i18nKey="add-inbox-preview.youre-all-set">
          <h1 className="inbox-preview-success-header">you are all set</h1>
        </Trans>
      </MessageWithHomeButton>
    );

  return children;
};

PageStates.propTypes = propTypes;

export default PageStates;
